<template>
  <main class="page-main esg">
    <section class="page-heading-wrap">
      <html-view tag="h3" class="page-heading" :value="$t('sustainability.head')" />
      <html-view class="page-heading-desc" :value="$t('sustainability.copy')" />
    </section>

    <section class="page-visual" data-style="show">
      <video
        muted
        loop
        autoplay
        playsinline
        poster="~@/static/image/sustainability/video.jpg"
      >
        <source src="~@/static/video/sustainability.mp4" type="video/mp4" media="(min-width:980px)">
        <source src="~@/static/video/sustainability_m.mp4" type="video/mp4" media="(max-width:980px)">
        Sorry, your browser doesn't support embedded videos.
      </video>
    </section>

    <navigation :tab-list="tabList" />

    <router-view />
  </main>
</template>

<script>
import navigation from '@/components/base/Navigation'

export default {
  components: {
    navigation
  },
  data () {
    return {
      tabList: [
        {
          pathname: 'sustainability-happiness',
          title: 'menuSustainability.happiness'
        },
        {
          pathname: 'sustainability-together',
          title: 'menuSustainability.togetherValue',
          params: {
            category: 0
          }
        },
        {
          pathname: 'sustainability-responsibility',
          title: 'menuSustainability.responsibility'
        }
      ]
    }
  },
}
</script>
